import { acceptHMRUpdate, defineStore } from 'pinia'

export const useBusinessRegister = defineStore('businessRegisterForm', {
	namespaced: true,
	state: () => ({
		interestData: {
			firstname: '',
			lastname: '',
			email: '',
			phone: '',
			company: '',
			zip: '',
		},

		companyInfo: {
			number_of_staff: '',
			size_of_fleet: '',
			city: '',
			state_dropdown_: '',
			message: '',
			product_type: '',
		},

		agree_to_carbar_privacy_policy_and_terms_and_conditions: 'Yes',

		errors: null,
		errorsRegisterForm: null,
		interestDataSubmitted: false,
		companyInfoSubmitted: false,
		isSubmitting: false,
	}),

	getters: {
		allInterestData: (state) => ({
			...state.interestData,
		}),

		allCompanyInfo: (state) => ({
			...state.companyInfo,
		}),

		isInterestDataSubmitted: (state) => state.interestDataSubmitted,
		isCompanyInfoSubmitted: (state) => state.companyInfoSubmitted,

		hasErrors: (state) => state.errors,
		hasErrorsEnquireForm: (state) => state.errorsRegisterForm,
	},

	actions: {
		// This is a 2-step registration form.
		// Step 1 - Personal info, returns UUID.
		async submitInterestForm() {
			await useExecuteRecaptcha('business_registration_step1').then(
				async (token) => {
					const isRecaptchaVerified = await useVerifyRecaptcha(token)

					if (!isRecaptchaVerified?.isVerified) {
						this.errorsRegisterForm = [isRecaptchaVerified?.message]
						return
					}

					try {
						const { data } = await useFetchForApi(
							'/business-registration',
							{
								method: 'POST',
								body: this.allInterestData,
							}
						)
						this.uuid = data.id
						this.interestDataSubmitted = true

						trackGtmEvent({
							event: 'business_register_interest_form_step1',
						})
					} catch (error) {
						this.handleErrorRegisterForm(error)
					}
				}
			)
		},
		// Step 2 - company and fleet info
		// Post all fields together with UUID
		async submitCompanyInfoForm() {
			this.checkUrlAndSetOption()

			await useExecuteRecaptcha('business_registration_step2').then(
				async (token) => {
					const isRecaptchaVerified = await useVerifyRecaptcha(token)

					if (!isRecaptchaVerified?.isVerified) {
						this.errorsRegisterForm = [isRecaptchaVerified?.message]
						return
					}

					try {
						await useFetchForApi('/business-registration', {
							method: 'POST',
							body: {
								...this.interestData,
								...this.companyInfo,
								uuid: this.uuid,
								agree_to_carbar_privacy_policy_and_terms_and_conditions:
									this
										.agree_to_carbar_privacy_policy_and_terms_and_conditions,
							},
						})
						this.companyInfoSubmitted = true

						trackGtmEvent({
							event: 'business_register_interest_form_success',
						})
						trackLinkedinEvent('BUSINESS_FORM')
					} catch (error) {
						this.handleErrorRegisterForm(error)
					}
				}
			)
		},

		checkUrlAndSetOption() {
			const route = useRoute()
			const { path } = route
			if (path === '/business/novated-lease') {
				this.companyInfo.product_type = 'Novated leasing'
			} else if (path === '/business/novated-subscription') {
				this.companyInfo.product_type = 'Novated subscription'
			} else if (path === '/business/novated-ev-subscription') {
				this.companyInfo.product_type = 'Novated EV subscription'
			} else if (
				path === '/business/fleet-subscription' ||
				path === '/business/fleet-subscription/small-business'
			) {
				this.companyInfo.product_type = 'Fleet subscription'
			} else if (path === '/business/tools-of-trade/employee-benefits') {
				this.companyInfo.product_type =
					'Tools of trades - Employee benefits'
			}
		},

		handleErrorRegisterForm(error) {
			const message =
				error.message || 'An error occurred. Please try again.'

			this.errorsRegisterForm = message
		},

		clearAllStates() {
			this.$reset()
		},

		clearErrors() {
			this.errors = null
			this.errorsRegisterForm = null
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(
		acceptHMRUpdate(useBusinessRegister, import.meta.hot)
	)
}
